/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { FormControl, Grid, MenuItem, Select, styled, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

const DateFilter = (props) =>
{
	const {
		value,
		onChange,
		dateFilterLabel = 'Date'
	} = props;
	// ALL_TIME	All time (no filter)
	// TODAY	Today only
	// LAST_WEEK	Last 7 days
	// LAST_MONTH	Last 30 days
	// LAST_YEAR	Last 365 days
	// YESTERDAY	Yesterday only
	// CUSTOM	Custom date range (requires startDate and endDate)
	const filterItems = [
		{ label: 'Any Time', value: 'ALL_TIME' },
		{ label: 'Today', value: 'TODAY' },
		{ label: 'Last 7 Days', value: 'LAST_WEEK' },
		{ label: 'Last 30 Days', value: 'LAST_MONTH' },
		{ label: 'Last 90 Days', value: 'LAST_90_DAYS' },
		{ label: 'Last One Year', value: 'LAST_YEAR' }
	];

	// Get valid filter values for validation
	const validFilterValues = filterItems.map((item) => item.value);

	// Validate query param value
	const validateFilterValue = (value) =>
	{
		return value && validFilterValues.includes(value) ? value : 'ALL_TIME';
	};

	const CustomSelect = styled(Select)({
		backgroundColor                      : '#F8F9FA',
		border                               : 'none',
		borderRadius                         : '4px',
		boxShadow                            : 'none',
		minWidth                             : '220px',
		'& .MuiOutlinedInput-notchedOutline' : {
			border : 'none'
		},
		'&:hover' : {
			backgroundColor : '#3FBBE11A'
		},
		'& .MuiSelect-select' : {
			padding  : '4px 10px',
			fontSize : 'var(--pixel14)'
		}
	});
	const [ searchParams, setSearchParams ] = useSearchParams();
	const queryParamValue = searchParams.get('dateFilter');
	const validatedQueryParamValue = validateFilterValue(queryParamValue);
	const [ localValue, setLocalValue ] = useState(validatedQueryParamValue);
	const isControlled = value !== undefined && onChange !== undefined;

	// Initialize from URL query param if not controlled
	useEffect(() =>
	{
		if (!isControlled)
		{
			const validatedValue = validateFilterValue(queryParamValue);

			setLocalValue(validatedValue);

			// Update URL if the param was invalid
			if (queryParamValue && queryParamValue !== validatedValue)
			{
				searchParams.set('dateFilter', validatedValue);
				setSearchParams(searchParams);
			}
		}
	}, [ queryParamValue ]);

	const handleSelectChange = (event) =>
	{
		const newValue = event.target.value;

		if (isControlled)
		{
			onChange(newValue);
		}
		else
		{
			setLocalValue(newValue);

			// Update query params
			searchParams.set('dateFilter', newValue);
			setSearchParams(searchParams);
		}
	};

	// Determine which value to use based on whether component is controlled
	const displayValue = isControlled ? value : localValue;

	return (
		<Grid item>
			<Typography pb={0.2} color={'var(--darkgray)'} fontSize={'var(--pixel10)'}>
				{dateFilterLabel}
			</Typography>
			<FormControl fullWidth>
				<CustomSelect
					value={displayValue}
					onChange={handleSelectChange}
					id='custom-range-select'
				>
					{filterItems.map((item, index) => (
						<MenuItem
							key={item?.value}
							value={item?.value}
							sx={{
								padding : '12px 16px'
							}}
						>
							{item.label}
						</MenuItem>
					))}
				</CustomSelect>
			</FormControl>
		</Grid>
	);
};

export default DateFilter;